export default __webpack_public_path__ + "assets/search.9b8257d6.svg";